module.exports = __webpack_public_path__ + "img/服务时长.44700bb2.png";